'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdScreenLockLandscape = function MdScreenLockLandscape(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm18 16.6v1.8h4v-1.8q0-0.7-0.6-1.3t-1.4-0.6-1.4 0.6-0.6 1.3z m-1.4 10q-0.7 0-1.1-0.4t-0.5-1.2v-5q0-0.7 0.5-1.2t1.1-0.4v-1.8q0-1.3 1-2.3t2.4-0.9 2.4 0.9 1 2.3v1.8q0.7 0 1.1 0.4t0.5 1.2v5q0 0.7-0.5 1.2t-1.1 0.4h-6.8z m15 1.8v-16.8h-23.2v16.8h23.2z m3.4-20q1.3 0 2.3 0.9t1.1 2.3v16.8q0 1.3-1.1 2.3t-2.3 0.9h-30q-1.3 0-2.3-0.9t-1.1-2.3v-16.8q0-1.3 1.1-2.3t2.3-0.9h30z' })
        )
    );
};

exports.default = MdScreenLockLandscape;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/screen-lock-landscape.js
// module id = 1927
// module chunks = 168707334958949